module.exports = __webpack_public_path__ + "static/img/carousel_3_optyeh_ar_16_9_w_2400.a36c5a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_3_optyeh_ar_16_9_w_2400.jpg
// module id = 1gse
// module chunks = 0